import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

const Hidden = ({
  children,
  xsUp,
  smUp,
  mdUp,
  lgUp,
  xlUp,
  smDown,
  mdDown,
  lgDown,
  xlDown,
  only,
}) =>{
  const theme = useTheme();

  const matchOnlyXs = useMediaQuery(theme.breakpoints.only('xs'));
  const matchOnlySm = useMediaQuery(theme.breakpoints.only('sm'));
  const matchOnlyMd = useMediaQuery(theme.breakpoints.only('md'));
  const matchOnlyLg = useMediaQuery(theme.breakpoints.only('lg'));
  const matchOnlyXl = useMediaQuery(theme.breakpoints.only('xl'));
 
  const matchUpXs = matchOnlyXs || matchOnlySm || matchOnlyMd || matchOnlyLg || matchOnlyXl
  const matchUpSm = matchOnlySm || matchOnlyMd || matchOnlyLg || matchOnlyXl
  const matchUpMd = matchOnlyMd || matchOnlyLg || matchOnlyXl
  const matchUpLg = matchOnlyLg || matchOnlyXl
  const matchUpXl = matchOnlyXl

  const matchDownSm = matchOnlyXs
  const matchDownMd = matchOnlyXs || matchOnlySm
  const matchDownLg = matchOnlyXs || matchOnlySm || matchOnlyMd;
  const matchDownXl = matchOnlyXs || matchOnlySm || matchOnlyMd || matchOnlyLg;
 
  const onlyArray = Array.isArray(only) ? only : only ? [only] : [];

  const shouldHide = (xsUp && matchUpXs) || (smUp && matchUpSm) || (mdUp && matchUpMd) || (lgUp && matchUpLg) || (xlUp && matchUpXl) ||
    (smDown && matchDownSm) || (mdDown && matchDownMd) || (lgDown && matchDownLg) || (xlDown && matchDownXl) ||
    (onlyArray.includes('xs') && matchOnlyXs) || (onlyArray.includes('sm') && matchOnlySm) || (onlyArray.includes('md') && matchOnlyMd) || (onlyArray.includes('lg') && matchOnlyLg) || (onlyArray.includes('xl') && matchOnlyXl)


  return shouldHide ? null : <>{children}</>
}
export default Hidden;
